import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=57196042&scoped=true"
import script from "./Answers.vue?vue&type=script&lang=js"
export * from "./Answers.vue?vue&type=script&lang=js"
import style0 from "./Answers.vue?vue&type=style&index=0&id=57196042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57196042",
  null
  
)

export default component.exports